import {useCallback, useMemo, useState} from "react";

import type {KeenSliderInstance, KeenSliderOptions} from "keen-slider";

import {createSliderConfig} from "../video-testimonials.config";
import type {VideoTestimonialItem} from "../video-testimonials.types";

type HookReturn = {
    currentIndex: number;
    sliderInstance: KeenSliderInstance | null;
    sliderConfig: KeenSliderOptions | undefined;
    handleSliderInit: (slider: KeenSliderInstance) => void;
};
export function useSliderState(videos: Array<VideoTestimonialItem>): HookReturn {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [sliderInstance, setSliderInstance] = useState<KeenSliderInstance | null>(null);

    const sliderConfig = useMemo(() => createSliderConfig(videos.length), [videos.length]);

    const handleSliderInit = useCallback((slider: KeenSliderInstance): void => {
        setSliderInstance(slider);

        const updateIndex = (instance: KeenSliderInstance): void => {
            const details = instance.track?.details;
            if (details) {
                setCurrentIndex(details.rel);
            }
        };

        slider.on("created", updateIndex);
        slider.on("slideChanged", updateIndex);
    }, []);

    return {
        currentIndex,
        sliderInstance,
        sliderConfig,
        handleSliderInit,
    };
}
